import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { AiFillHome } from "react-icons/ai";
import { AiFillShop } from "react-icons/ai";
import { FaComment } from "react-icons/fa";
import { addFooterItemAction } from '../../redux/actions'

const footerStyle = {
	backgroundColor: 'white',
	fontSize: '20px',
	color: 'white',
	borderTop: '1px solid #E7E7E7',
	textAlign: 'center',
	paddingTop:'7px',
	paddingBottom: '7px',
	position: 'fixed',
	bottom: '0',
	width: '100%',
	zIndex: 3
};

const footerLetters = {
	fontSize: 13,
	color: 'grey'
};

class Footer extends React.Component {

	state = {
		categories: 0	,
		aboutUs: 0,
		shoppingCart: 0,
	}

	changeState = (categories, aboutUs, shoppingCart) => {
		this.props.addFooterItem({categories, aboutUs, shoppingCart})
			
	}
	
	render() {
		return (
			<Fragment>
				<div className="col-md-3 offset-md-4" style={footerStyle}>
					<div className="row justify-content-center align-items-center">
            
						<div className="col-4 ">
							<Link key={'1'} to={{ pathname: `/${this.props.userName}/products` }} onClick={() => this.changeState(1,0,0)}> 
								<div className="row justify-content-center p-0">
									<AiFillHome size={25} color={this.props.footerItem.categories === 0 ? 'gray' : this.props.shopColor} />
								</div>
								<div className="row justify-content-center p-0">
									<span style={footerLetters}> Categorías </span>
								</div>
							</Link>
						</div>

						<div className="col-4">
							<Link key={'2'} to={{ pathname: `/${this.props.userName}/nosotros`}} onClick={() => this.changeState(0,1,0)}>
								<div className="row justify-content-center p-0">
									<AiFillShop size={25} color={this.props.footerItem.aboutUs === 0 ? 'gray' : this.props.shopColor}  />
								</div>
								<div className="row justify-content-center p-0">
									<span style={footerLetters}> Sobre Nosotros </span>
								</div>
							</Link>
						</div>

						<div className="col-4">
							<Link key={'3'} to={{ pathname: `/${this.props.userName}/commentary` }} onClick={() => this.changeState(0,0,1)}>
								<div className="row justify-content-center p-0">
									<FaComment size={25} color={this.props.footerItem.shoppingCart === 0 ? 'gray' : this.props.shopColor}  />
								</div>
								<div className="row justify-content-center p-0">
									<span style={footerLetters}> Sugerencias </span>
								</div>
							</Link>
						</div>

					</div>
				</div>
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	userName: state.userName,
	footerItem: state.footerItem,
	shopColor: state.shopColor,
});

const mapDispatchToProps = (dispatch) => ({
	addFooterItem(item) {
		dispatch(addFooterItemAction(item));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
